import { generatedApi } from '@api/generatedApi';
import { djangoApi } from '@api/djangoApi'; // Legacy API for endpoints not in OpenAPI schema
import { emailApi } from '@api/emailApi'; // Legacy - use emailServiceApi for new code
import { warmupPoolApi } from '@api/warmupPoolApi'; // Legacy - use emailServiceApi for new code
import { emailServiceApi } from '@api/generatedEmailApi'; // New: RTK Query codegen from NestJS OpenAPI
import { scraperApi } from '@api/scraperApi'; // Django scraper API (VisualScrapeBuilder etc.)
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

/** side effect import for cache invalidation */
import '@api/enhanceGeneratedApi';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [generatedApi.reducerPath]: generatedApi.reducer, // Primary Django API (OpenAPI codegen)
    [djangoApi.reducerPath]: djangoApi.reducer,       // Legacy Django API (for endpoints not in schema)
    [emailApi.reducerPath]: emailApi.reducer,         // Legacy email API (via Django proxy)
    [warmupPoolApi.reducerPath]: warmupPoolApi.reducer, // Legacy warmup pool API
    [emailServiceApi.reducerPath]: emailServiceApi.reducer, // New: Direct NestJS email service API
    [scraperApi.reducerPath]: scraperApi.reducer,     // Django scraper API
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(generatedApi.middleware)
      .concat(djangoApi.middleware)
      .concat(emailApi.middleware)
      .concat(warmupPoolApi.middleware)
      .concat(emailServiceApi.middleware)
      .concat(scraperApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
